import { render, staticRenderFns } from "./TeleMarketUserStatistics.vue?vue&type=template&id=65b781d6&scoped=true"
import script from "./TeleMarketUserStatistics.vue?vue&type=script&lang=js"
export * from "./TeleMarketUserStatistics.vue?vue&type=script&lang=js"
import style0 from "./TeleMarketUserStatistics.vue?vue&type=style&index=0&id=65b781d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b781d6",
  null
  
)

export default component.exports